exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pad[data-v-d5b87c2e]{\n  padding:1em;\n}\n", ""]);

// exports
